import { IDepartmentResources } from "../../../../models/master/departmentResources";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { useNavigate } from "react-router-dom";
import { IStaffDepartmentResource } from "../../../../models/dashboard/staffDashboard";
import { connect, useDispatch } from "react-redux";
import { getDepartmentResources } from "../../../../action/masters/departmentResourceActionCreator";
import { useEffect } from "react";
import { setDepartmentResources } from "../../../../store/slices/master/departmentResource";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const DepartmentResources = (props: IStaffDepartmentResource) => {
  const { departmentResources, getDepartmentResources, snapShots } = props;
  const navigate = useNavigate();

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.departmentResources
  );

  const handleViewALL = () => {
    navigate(ROUTER_URL.RESOURCES);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getDepartmentResources(pageBlockId.departmentResources, limit.three);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setDepartmentResources([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Department Resources</h2>
          <a
            onClick={handleViewALL}
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All Resources"
          >
            View All
          </a>
        </div>
        <div className="row stud-dash-apps">
          {departmentResources?.map((resource: IDepartmentResources) => (
            <div className="col-lg-4">
              <div className="appcard">
                <a href={resource.url} target="_blank">
                  <img src={baseURL + resource.image} />
                  <h3>{resource.name}</h3>
                  <span>
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getDepartmentResources: (pageBlockId?: number, noOfItems?: number) =>
    getDepartmentResources(pageBlockId, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    departmentResources: state.departmentResource.departmentResources,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepartmentResources);
